import { connect } from 'react-redux';
import { AppState } from '../../app-state';
import { selectSourceDocumentIsEditable } from '../../documents/selectors/source-document.selectors';
import {
  Granularity,
  selectVersion,
  setGranularity,
  toggleDiffFilter,
  toggleDiffMode,
} from '../actions/version-history.actions';
import { VersionHistoryToolbar } from '../components/version-history-toolbar.component';
import {
  selectDiffFilterActive,
  selectDiffModeEnabled,
  selectFilteredSaveEvents,
  selectGranularity,
  selectSelectedSaveEventId,
  selectSelectedVersionIndex,
  selectVersionDiff,
  selectVersionHistoryLoading,
  selectVersionHistorySaveEvents,
} from '../selectors/version-history.selectors';

const mapStateToProps = (state: AppState) => ({
  saveEvents: selectVersionHistorySaveEvents(state),
  filteredEvents: selectFilteredSaveEvents(state),
  granularity: selectGranularity(state),
  selectedSaveEventId: selectSelectedSaveEventId(state),
  selectedIndex: selectSelectedVersionIndex(state),
  loading: selectVersionHistoryLoading(state),
  diff: selectVersionDiff(state),
  diffModeEnabled: selectDiffModeEnabled(state),
  diffFilterActive: selectDiffFilterActive(state),
  isEditable: selectSourceDocumentIsEditable(state),
});

const mapDispatchToProps = {
  onSelectVersion: (saveEventId: number | null) => selectVersion(saveEventId),
  onSetGranularity: (g: Granularity) => setGranularity(g),
  onToggleDiffMode: (enabled: boolean) => toggleDiffMode(enabled),
  onToggleDiffFilter: () => toggleDiffFilter(),
};

// Only render when not editable (view mode)
const mergeProps = (stateProps: any, dispatchProps: any) => {
  if (stateProps.isEditable) {
    return { ...stateProps, ...dispatchProps, hidden: true };
  }
  return { ...stateProps, ...dispatchProps, hidden: false };
};

export const ConnectedVersionHistoryToolbar = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(({ hidden, ...props }: any) => {
  if (hidden) return null;
  return VersionHistoryToolbar(props);
});
